export {default as voronoi} from "./voronoi";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-voronoi/src/index.js
// module id = null
// module chunks = 